import React, {createContext, useState, useEffect} from 'react'

export const ThemeContext = createContext()

export function ThemeContextProvider(props) {

  const getInitialTheme = () => {
        const stored = localStorage.getItem('darkTheme')
        if (stored !== null) return stored === 'true'
        return window.matchMedia('(prefers-color-scheme: dark)').matches
  }

  const [darkTheme, setDarkTheme] = useState(getInitialTheme)

  const toggleTheme = () => {
    setDarkTheme(!darkTheme)
    localStorage.setItem('darkTheme', !darkTheme)
  }

  useEffect(() => {
    document.body.classList.toggle('dark', darkTheme)
    document.body.classList.toggle('light', !darkTheme)
  }, [darkTheme])


  return (
    <ThemeContext.Provider value={{setDarkTheme, darkTheme, toggleTheme}}>
        {props.children}
    </ThemeContext.Provider>
  )
}
